import { NavLink } from 'react-router-dom'
import { observer, Observer } from 'mobx-react-lite'
import getMenuItems, { MenuItem } from 'components/Dashboard/menuConfig'
import NotificationBubble from 'components/Dashboard/common/NotificationBubble'
import Logo from 'components/common/Logo'
import SideNavSingleton from 'singletons/SideNav'
import ArrowLeft from '@ui-components-3/icons/lib/solid/ArrowLeft'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type SectionsListProps = {
  menuItems: MenuItem[]
}

const SectionsList = ({ menuItems }: SectionsListProps) => {
  return (
    <ul className="pt-1 pb-2 relative list-none">
      {menuItems?.map(({ title, route, exact, IconComponent, getNotificationsAmount }) => {
        return (
          <li key={title}>
            <NavLink
              end={exact}
              to={route}
              className={({ isActive }) =>
                classNames(
                  'relative h-[66px] group flex items-center px-10 py-3 typography-body-xl text-[20px] text-white font-semibold border-l-4 hover:border-l-[#2FAFCC] hover:bg-[#0C3152]',
                  isActive ? 'border-l-[#2FAFCC] bg-[#0C3152] is-active' : 'border-l-transparent',
                )
              }
            >
              <span className="w-8">
                {!!IconComponent && (
                  <IconComponent
                    aria-hidden="true"
                    className="w-[18px] h-[18px] group-hover:text-[#2FAFCC] group-[.is-active]:text-[#2FAFCC]"
                  />
                )}
              </span>
              <span className="pr-4">{title}</span>
              <Observer>
                {() => {
                  const amount = getNotificationsAmount ? getNotificationsAmount() : 0
                  return amount ? <NotificationBubble amount={amount} /> : null
                }}
              </Observer>
            </NavLink>
          </li>
        )
      })}
    </ul>
  )
}

const DrawerContent = () => {
  return (
    <div>
      <Observer>
        {() => (
          <div className="flex items-baseline justify-center">
            {SideNavSingleton.collapsable ? (
              <button
                type="button"
                className="btn-small btn-secondary-borderless relative pr-3"
                onClick={() => SideNavSingleton.setIsOpen(false)}
              >
                <ArrowLeft aria-label="Close" className="h-6 absolute top-5" />
              </button>
            ) : null}
            <Logo
              variant="white"
              className={`${SideNavSingleton.collapsable ? 'w-[64%] mr-2' : 'mx-auto w-[70%]'}  my-s`}
            />
          </div>
        )}
      </Observer>
      <SectionsList menuItems={getMenuItems()} />
    </div>
  )
}

export default observer(DrawerContent)
